import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import snakeCaseKeys from 'snakecase-keys';
import { useAbility } from '@casl/react';
import PropTypes from 'prop-types';

import { Button, Card, Col, Modal, Row, Accordion } from 'react-bootstrap';
import { Icon } from '@material-ui/core';
import {
  debounceIndexEmployeesRequest,
  deactivateEmployeeRequest,
  destroyEmployeeRequest,
  importEmployeeRequest,
  preImportEmployeeRequest,
  exportEmployeesRequest,
  importTemplateEmployeeRequest,
  sendActivationEmailsRequest,
  sendActivationEmailRequest,
  bulkExportDocumentsRequest
} from '../../../requests/employees';

import {
  preImportContractRequest,
  importContractRequest,
  importTemplateContractRequest
} from '../../../requests/contracts';
import createTemplatePdfRequest from '../../../requests/templatePdfs';
import { createOvertimeAgreementRequest } from '../../../requests/overtimeAgreements';
import { sendAlert } from '../../../actions/utils';
import { downloadFile } from '../../../services/utils';
import AnnexContractForm from '../../../components/TemplatePdfs/AnnexContractForm';
import OvertimeAgreementsForm from '../../../components/OvertimeAgreements/OvertimeAgreementsForm';
import { AbilityContext } from '../../../config/abilityContext';
import {
  ComponentDataTable,
  DefaultModal,
  SimpleCenteredModal,
  ImportModal,
  ImportActions,
  EmployeeActions,
  BasicDropdown
} from '../../../components';
import EmployeeFilter from '../../Employee/EmployeeFilter';
import './Style.scss';
import Errors from '../../FileBroadcast/DTElectronic/Errors';

const items = (clickHandler, item, employeeMenu) => {
  const actions = [];
  if (employeeMenu[1]) {
    actions.push({
      key: 'send_activation_email',
      title: 'Enviar correo de enrolamiento',
      icon: <Icon icon="paper-plane-outline" height="16px" width="16px" style={{ marginRight: 5 }} />,
      props: {
        onClick: () => clickHandler(item, 'send_activation_email'),
        disabled: item.enrolled
      }
    });
  }

  if (employeeMenu[2]) {
    actions.push({
      key: 'show',
      title: `Ver`,
      icon: <Icon icon="eye" height="16px" width="16px" style={{ marginRight: 5 }} />,
      props: {
        onClick: () => clickHandler(item, 'show')
      }
    });
  }
  if (employeeMenu[3]) {
    actions.push({
      key: 'edit',
      title: `Editar`,
      icon: <Icon icon="pencil" height="16px" width="16px" style={{ marginRight: 5 }} />,
      props: {
        onClick: () => clickHandler(item, 'edit')
      }
    });
  }
  if (employeeMenu[5]) {
    actions.push({
      key: 'archive',
      title: item.active ? 'Desactivar' : 'Activar',
      icon: <Icon icon="archive" height="16px" width="16px" style={{ marginRight: 5 }} />,
      props: {
        onClick: () => clickHandler(item, 'archive')
      }
    });
  }
  if (employeeMenu[4]) {
    actions.push({
      key: 'destroy',
      title: 'Eliminar',
      icon: <Icon icon="trash" height="16px" width="16px" style={{ marginRight: 5 }} />,

      props: {
        onClick: () => clickHandler(item, 'destroy'),
        disabled: item.enrolled_or_contract
      }
    });
  }

  return actions;
};
const ExpandedComponent = ({ data, employeeMenu, handleActions }) => {
  return (
    <Card>
      <Card.Body className="div-content-expander">
        <Row>
          <Col>
            <div className="info">
              <span className="type">Area:</span>
              <span className="line" />
              <span className="answer"> {data.job_management}</span>
            </div>
            <div className="info">
              <span className="type">Cargo:</span>
              <span className="line" />
              <span className="answer"> {data.job_title}</span>
            </div>
            <div className="info">
              <span className="type">Inicio de Contrato:</span>
              <span className="line" />
              <span className="answer"> {data.last_contract_start_date}</span>
            </div>
            <div className="info">
              <span className="type">Fin de Contrato:</span>
              <span className="line" />
              <span className="answer"> {data.last_contract_end_date}</span>
            </div>
            <div className="info">
              <span className="type">Estado:</span>
              <span className="line" />
              <span className="answer"> {data.active ? 'Activo' : 'Inactivo'}</span>
            </div>
            <div className="info">
              <span className="line" />
              <span className="answer">
                {employeeMenu.some(row => row) && (
                  <BasicDropdown
                    variant="outline-primary"
                    noArrow
                    block
                    right
                    titleDrop={<span className="align-middle">Acciones</span>}
                    items={items(handleActions, data, employeeMenu)}
                  />
                )}
              </span>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
const EmployeeDataTable = ({
  customParams,
  clickRoute,
  columns,
  refreshDashboard,
  withMassActions,
  removeExpireFilter,
  importContract,
  showActions,
  showFilters
}) => {
  const [onRequest, setOnRequest] = useState(true);
  const [employees, setEmployees] = useState([]);
  const [employeeIds, setEmployeeIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [selectedCount, setSelectedCount] = useState(0);
  const [simpleModalShow, setSimpleModalShow] = useState(false);
  const [overtimeAgreementsShow, setOvertimeAgreementsShow] = useState(false);
  const [amount, setAmount] = useState(0);
  const [moreData, setMoreData] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalItem, setModalItem] = useState({});
  const [modalBody, setModalBody] = useState('');
  const [modalAction, setModalAction] = useState(() => null);
  const [modalTitle, setModalTitle] = useState('');
  const [filters, setFilters] = useState({ active: true });
  const [query, setQuery] = useState({});
  const [importTitle, setImportTitle] = useState('');
  const [importBody, setImportBody] = useState({});
  const [importShow, setImportShow] = useState(false);
  const [importSize, setImportSize] = useState('lg');
  const [advanceParams, setAdvanceParams] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState('0');
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const ability = useAbility(AbilityContext);
  const isMobile = window.innerWidth <= 767;

  const refreshTable = () => {
    setMoreData(!moreData);
    if (refreshDashboard) refreshDashboard();
  };

  const handleFilterUpdate = filterKey => {
    const isInactive = filterKey === 'inactive';

    if (filters[filterKey]) {
      const newFilters = { ...filters };
      if (!isInactive) delete newFilters[filterKey];
      if (filters.inactive === true && isInactive) {
        delete newFilters.active;
        newFilters.inactive = false;
      }
      setFilters(newFilters);
    } else {
      const newFilters = { ...filters, [isInactive ? 'active' : filterKey]: !isInactive };
      if (isInactive) newFilters.inactive = true;
      if (filterKey === 'active') newFilters.inactive = false;
      setFilters(newFilters);
    }
    refreshTable();
  };

  const manageMountFilters = () => {
    const newFilters = new URLSearchParams(location.search).get('filters');
    if (newFilters) handleFilterUpdate(newFilters);
  };

  useEffect(manageMountFilters, []);

  const handleSuccessIndex = response => {
    const { data, metadata } = response.data;
    setEmployees(data);
    setAmount(metadata.amount);
  };

  const handleFilterAdvance = params => {
    setAdvanceParams(params);
    refreshTable();
  };

  const handleRequest = async params => {
    setOnRequest(true);
    setQuery({ ...params, ...filters, ...advanceParams });
    debounceIndexEmployeesRequest({
      dispatch,
      params: { ...customParams, ...params, ...filters, ...advanceParams, is_dt: false },
      successCallback: handleSuccessIndex,
      callback: () => setOnRequest(false)
    });
  };

  const handleFailureRequest = error => {
    const { response } = error;
    if (!response) {
      dispatch(sendAlert({ kind: 'error', message: error.message }));
    } else {
      let errorMessage = response.statusText;
      if (response.data && response.data.message) {
        errorMessage = response.data.message;
      }
      dispatch(sendAlert({ kind: 'error', message: errorMessage }));
    }
    setOnRequest(false);
    setSimpleModalShow(false);
    setModalShow(false);
  };

  const handleModalClose = () => {
    setModalShow(false);
    setOnRequest(false);
  };

  const handleMassAnnex = () => {
    setEmployeeIds(selectedRows.map(employee => employee.id));
    setSimpleModalShow(true);
  };

  const handleMassOvertimeAgreement = () => {
    setEmployeeIds(selectedRows.map(employee => employee.id));
    setOvertimeAgreementsShow(true);
  };

  const handleMassArchive = (selectedArray = [], extraParams = {}) => {
    let employeesSelected = [...selectedArray, ...selectedRows];
    const myParams = { employee_ids: employeesSelected.map(employee => employee.id), ...extraParams };
    deactivateEmployeeRequest({
      dispatch,
      params: myParams,
      successCallback: () => {
        refreshTable();
        dispatch(sendAlert({ kind: 'success', message: 'Acción realizada con éxito' }));
        setClearSelectedRows(!clearSelectedRows);
        employeesSelected = [];
      },
      callback: () => {
        setModalShow(false);
        setOnRequest(false);
      }
    });
  };

  const handleModalConfirm = item => {
    handleMassArchive([item]);
    setModalShow(false);
    setOnRequest(true);
  };

  const handleWarningContractConfirm = (item = [], contractIds = []) => {
    handleMassArchive(item, { contract_ids: contractIds });
    setImportShow(false);
    setOnRequest(true);
  };

  const handleDestroy = item => {
    setOnRequest(true);
    destroyEmployeeRequest(item.id, {
      dispatch,
      successCallback: () => {
        refreshTable();
        dispatch(sendAlert({ kind: 'success', message: 'Empleado eliminado con éxito' }));
      },
      callback: () => {
        setModalShow(false);
        setOnRequest(false);
      }
    });
  };

  const handleSendActivationEmail = item => {
    sendActivationEmailRequest(item.id, {
      dispatch,
      successCallback: response => {
        dispatch(sendAlert({ kind: 'success', message: response?.data.message }));
      },
      callback: () => {
        setModalShow(false);
        setOnRequest(false);
      }
    });
  };

  const handleMassiveChangeStatus = () => {
    const allWithContracts = selectedRows.filter(employee => !employee.active && employee.has_recent_ended_contract);
    if (allWithContracts.length > 0) {
      const errors = allWithContracts.map(employee => {
        return `${employee.short_name} - Contrato (${employee.last_contract_correlative})`;
      });
      const contractIds = allWithContracts.map(employee => employee.last_contract_id);
      setImportSize('md');
      setImportTitle('Advertencia');
      setImportBody(
        <>
          <Modal.Body>
            <p>
              Los siguientes empleados tienen contratos <span className="bold"> finiquitados</span>,
            </p>
            <Errors errorLabels={errors} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" className="mr-3" onClick={() => handleWarningContractConfirm([])}>
              Continuar Sin Renovar
            </Button>
            <Button variant="info" className="mr-3" onClick={() => handleWarningContractConfirm([], contractIds)}>
              Activar y Renovar
            </Button>
          </Modal.Footer>
        </>
      );
      setImportShow(true);
      return;
    }
    handleMassArchive();
  };

  const handleSingleChangeStatus = item => {
    if (!item.active && item.has_recent_ended_contract) {
      setImportSize('md');
      setImportTitle('Advertencia');
      setImportBody(
        <>
          <Modal.Body>
            <p>
              El contrato ({item.last_contract_correlative}) del empleado se encuentra
              <span className="bold"> finiquitado</span>,
            </p>
            <p>¿Desea Actívarlo nuevamente o realizar un Nuevo Contrato?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" className="mr-3" onClick={() => handleWarningContractConfirm([item])}>
              Crear Nuevo Contrato
            </Button>
            <Button
              variant="info"
              className="mr-3"
              onClick={() => handleWarningContractConfirm([item], [item.last_contract_id])}
            >
              Renovar Contrato ({item.last_contract_correlative})
            </Button>
          </Modal.Footer>
        </>
      );
      setImportShow(true);
      return;
    }
    setModalShow(true);
    setModalItem(item);
    setModalBody(`¿Estás seguro que deseas ${item.active ? 'desactivar' : 'activar'} a ${item.full_name}?`);
    setModalTitle(`${item.active ? 'Desactivar' : 'Activar'} Empleado`);
    setModalAction(() => handleModalConfirm);
  };

  const handleActions = (item, action) => {
    switch (action) {
      case 'show':
        history.push(`${clickRoute || '/employees'}/${item.id}`);
        break;
      case 'edit':
        history.push(`${clickRoute || '/employees'}/${item.id}/edit`);
        break;
      case 'archive':
        handleSingleChangeStatus(item);
        break;
      case 'destroy':
        setModalShow(true);
        setModalItem(item);
        setModalBody(
          `¿Estás seguro que deseas eliminar a ${item.full_name}? Esta acción no es reversible y se eliminará toda su información.`
        );
        setModalTitle('Eliminar Empleado');
        setModalAction(() => handleDestroy);
        break;
      case 'send_activation_email':
        setModalShow(true);
        setModalItem(item);
        setModalBody(`¿Estás seguro que deseas enviar el correo de enrolamiento a ${item.full_name}?`);
        setModalTitle('Enviar correo de enrolamiento');
        setModalAction(() => handleSendActivationEmail);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
        break;
    }
  };

  const onRowClicked = item => {
    history.push(`${clickRoute}/${item.id}`);
  };

  const handleSuccessPdf = (modal, templateType) => {
    let message = 'Contratos agregados a la carpeta del colaborador';
    setOnRequest(false);
    if (modal) {
      const documentNames = { contract_annex: 'Anexo de Contrato' };
      message = `${documentNames[templateType]} agregados a la carpeta del colaborador`;

      setSimpleModalShow(false);
    }
    setClearSelectedRows(!clearSelectedRows);
    dispatch(sendAlert({ kind: 'success', message }));
  };

  const handleSuccessOvertimeAgreements = resp => {
    setOnRequest(false);
    setMoreData(!moreData);

    const { add, errors } = resp.data;

    setOvertimeAgreementsShow(false);
    setClearSelectedRows(!clearSelectedRows);
    if (add.length > 0) {
      dispatch(sendAlert({ kind: 'success', message: add.toString() }));
    }

    if (errors.length > 0) {
      dispatch(sendAlert({ kind: 'error', message: errors.toString() }));
    }
  };

  const handleFailurePdf = error => {
    setOnRequest(false);
    setMoreData(!moreData);
    const { response } = error;
    if (!response) {
      dispatch(sendAlert({ kind: 'error', message: error.message }));
    } else {
      let errorMessage = response.statusText;
      if (response.data && response.data.message) {
        errorMessage = response.data.message;
      }
      dispatch(sendAlert({ kind: 'error', message: errorMessage }));
      setSimpleModalShow(false);
      setOvertimeAgreementsShow(false);
    }
  };

  const createPdfRequest = (params, modal) => {
    const documentType = params?.template_pdf?.document_type;
    createTemplatePdfRequest({
      dispatch,
      params,
      formData: true,
      successCallback: () => handleSuccessPdf(modal, documentType),
      failureCallback: handleFailurePdf
    });
  };

  const createOvertimeAgreement = params => {
    createOvertimeAgreementRequest({
      dispatch,
      params,
      formData: true,
      successCallback: handleSuccessOvertimeAgreements
    });
  };

  const handleAnnexCreateRequest = templatePdf => {
    setOnRequest(true);
    createPdfRequest(snakeCaseKeys(templatePdf), true);
  };

  const handlecreateOvertimeAgreementRequest = overtimeAgreement => {
    setOnRequest(true);
    createOvertimeAgreement(snakeCaseKeys(overtimeAgreement));
  };

  const handleMassContract = () => {
    const ids = selectedRows.map(employee => employee.id);
    const myParams = { template_pdf: { employee_ids: ids, document_type: 'work_contract' } };
    setOnRequest(true);
    createPdfRequest(myParams);
  };

  const handleMassSendActivationEmail = () => {
    const myParams = {
      employee_attributes: selectedRows.reduce((acc, current) => {
        acc.push({
          id: current.id,
          company_id: current.company.value
        });
        return acc;
      }, [])
    };
    setOnRequest(true);

    sendActivationEmailsRequest({
      dispatch,
      params: myParams,
      formData: true,
      successCallback: response => {
        let message = '';
        const { errors, success } = response.data;
        if (success.length >= 1) {
          message = (
            <h4 className="text-success mb-3 enrrolment mt-md-n1">
              Correo(s) de enrolamiento al sistema enviado(s) con éxito
            </h4>
          );
        }
        if (success.length === 0) {
          message = (
            <h4 className="text-danger mb-3 enrrolment mt-md-n1">
              No se enviaron correo(s) de enrolamiento al sistema
            </h4>
          );
        }
        refreshTable();
        setImportTitle('Envío de correo de enrolamiento');
        if (errors.length > 1) {
          setImportBody(
            <>
              {message}
              <p>
                Los correos de enrolamiento no fueron enviados a los siguientes colaboradores:&nbsp;
                <strong>{errors.join(', ')}</strong>.&nbsp; Ya se encuentra enrolado(a) en el sistema.
              </p>
            </>
          );
        }
        if (errors.length === 1) {
          setImportBody(
            <>
              {message}
              <p>
                El correo de enrolamiento no fue enviado al colaborador&nbsp;
                <strong>{errors[0].trim()}</strong>.&nbsp; Ya se encuentra enrolado(a) en el sistema.
              </p>
            </>
          );
        }
        if (errors.length === 0) {
          setImportBody(
            <>
              <center>{message}</center>
            </>
          );
        }
        setImportSize('lg');
        setImportShow(true);
        setOnRequest(false);
      },
      failureCallback: error => {
        const { data } = error.response;
        setOnRequest(false);
        dispatch(sendAlert({ kind: 'error', message: data.message }));
      }
    });
  };

  const handleExportRequest = () => {
    setOnRequest(true);
    exportEmployeesRequest({
      dispatch,
      params: query,
      successCallback: response => {
        downloadFile(response);
        setOnRequest(false);
        setModalShow(false);
      },
      failureCallback: handleFailureRequest
    });
  };

  const handleImportModalExceptions = error => {
    if (error?.response?.status === 422) {
      const alertInfo = <pre>{error?.response?.data?.message}</pre>;
      setModalTitle('Información Relevante');
      setModalShow(true);
      setModalBody(alertInfo);
      setModalAction(() => handleModalClose);
    } else {
      dispatch(sendAlert({ kind: 'error', message: error?.response?.data?.message }));
    }
  };

  const handleBulkDownloadDocuments = () => {
    setOnRequest(true);
    bulkExportDocumentsRequest({
      dispatch,
      params: {
        employee_ids: selectedRows.map(employee => employee.id)
      },
      successCallback: response => {
        dispatch(sendAlert({ kind: 'success', message: response.data.message }));
        setOnRequest(false);
        setModalShow(false);
      },
      failureCallback: handleFailureRequest
    });
  };

  const handleMassAction = action => {
    switch (action) {
      case 'contract':
        handleMassContract();
        break;
      case 'annex':
        handleMassAnnex();
        break;
      case 'overtime_agreements':
        handleMassOvertimeAgreement();
        break;
      case 'archive': {
        if (filters.active) handleMassArchive();
        else handleMassiveChangeStatus();
        break;
      }
      case 'send_activation_email':
        handleMassSendActivationEmail();
        break;
      case 'import':
        setImportShow(true);
        if (importContract) {
          setImportTitle('Importar Contratos');
          setImportBody(
            <ImportModal
              onDropUploaded={preImportContractRequest}
              handleTemplate={importTemplateContractRequest}
              hideModal={() => setImportShow(false)}
              onHide={importContractRequest}
              updateData={() => refreshTable()}
              handleExceptions={handleImportModalExceptions}
            />
          );
        } else {
          setImportTitle('Importar Colaboradores');
          setImportBody(
            <ImportModal
              onDropUploaded={preImportEmployeeRequest}
              handleTemplate={importTemplateEmployeeRequest}
              hideModal={() => setImportShow(false)}
              onHide={importEmployeeRequest}
              updateData={() => refreshTable()}
              handleExceptions={handleImportModalExceptions}
            />
          );
        }
        break;
      case 'export':
        setModalTitle('Exportar empleados');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas exportar empleados?');
        setModalAction(() => handleExportRequest);
        break;
      case 'download-documents':
        setModalTitle('Descargar documentos');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas descargar documentos?');
        setModalAction(() => handleBulkDownloadDocuments);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };

  const handleFilters = action => {
    switch (action) {
      case 'toExpire':
        handleFilterUpdate('toExpire');
        break;
      case 'activeStaffing':
        handleFilterUpdate('activeStaffing');
        break;
      case 'toEnroll':
        handleFilterUpdate('toEnroll');
        break;
      case 'active':
        handleFilterUpdate('active');
        break;
      case 'inactive':
        handleFilterUpdate('inactive');
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };

  const handleSelectedRows = item => {
    setSelectedRows(item.selectedRows);
    setSelectedCount(item.selectedCount);
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'company':
        return { sort_companies: name };
      case 'correlative_identification':
        return { sort_correlatives: name };
      case 'job_title':
        return { sort_job_titles: name };
      case 'job_management':
        return { sort_job_managements: name };
      case 'start_date':
        return { sort_contracts: name };
      case 'end_date':
        return { sort_end_date: name };
      default:
        return { sort_column: name };
    }
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: '55px'
      }
    },
    headCells: {
      style: {
        textAlign: 'left'
      }
    },
    cells: {
      style: {
        overflowY: 'initial !important'
      }
    }
  };

  const employeeMenu = [
    ability.can('force_enrollment', 'Employee'),
    ability.can('send_activation_email', 'Employee'),
    ability.can('show', 'Employee'),
    ability.can('update', 'Employee'),
    ability.can('destroy', 'Employee'),
    ability.can('deactivate', 'Employee')
  ];
  // data provides access to your row data

  return (
    <>
      <Accordion className="asdasd" activeKey={activeAccordion} onSelect={key => setActiveAccordion(key)}>
        <Card className="mb-3">
          <Col className="top-header-employee py-2">
            <Accordion.Toggle
              as={Col}
              eventKey="0"
              className="card-header-title d-flex justify-content-between align-items-center"
              onClick={() => setActiveAccordion(activeAccordion === '0' ? null : '0')}
              style={{ textAlign: 'right', cursor: 'pointer' }}
            >
              <span>FILTROS DE BÚSQUEDA</span>
              <span className="h4 mr-2">{activeAccordion === '0' ? '−' : '+'}</span>
            </Accordion.Toggle>
          </Col>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="employee-filters">
              {showFilters && <EmployeeFilter formRequest={handleFilterAdvance} />}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      <div className="data-table-yellow">
        <ComponentDataTable
          onRequest={onRequest}
          columns={columns(handleActions, employeeMenu, isMobile, filters.active)}
          customStyles={customStyles}
          data={employees}
          totalRows={amount}
          handleSortCase={sortColumnCase}
          moreData={moreData}
          selectableRows={withMassActions}
          clearSelectedRows={clearSelectedRows}
          onRowClicked={onRowClicked}
          resourceRequest={handleRequest}
          pointerOnHover
          expandableRows={isMobile}
          expandableRowExpanded={() => isMobile}
          expandableRowsComponent={
            isMobile ? (
              <ExpandedComponent handleActions={handleActions} employeeMenu={employeeMenu} isMobile={isMobile} />
            ) : (
              undefined
            )
          }
          expandableRowsHideExpander
          massActions={
            <>
              <ImportActions handleClick={handleMassAction} model="Employee" disabledExport={!selectedCount} />
              <EmployeeActions
                handleClick={handleMassAction}
                handleFilters={handleFilters}
                disabled={!selectedCount || onRequest}
                removeExpireFilter={removeExpireFilter}
                filters={filters}
                showActions={showActions}
              />
            </>
          }
          withMassActions={withMassActions}
          onSelectedRowsChange={handleSelectedRows}
        />
      </div>

      <DefaultModal
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        handleClose={handleModalClose}
        handleConfirm={() => modalAction(modalItem)}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
        disabled={onRequest}
      />
      <SimpleCenteredModal
        title="Anexo Contrato"
        body={<AnnexContractForm formRequest={handleAnnexCreateRequest} employeeIds={employeeIds} />}
        show={simpleModalShow}
        onHide={() => setSimpleModalShow(false)}
      />
      <SimpleCenteredModal
        title="Pactos de horas extras"
        body={<OvertimeAgreementsForm formRequest={handlecreateOvertimeAgreementRequest} employeeIds={employeeIds} />}
        show={overtimeAgreementsShow}
        onHide={() => {
          setOvertimeAgreementsShow(false);
          setMoreData(!moreData);
        }}
      />
      <SimpleCenteredModal
        title={importTitle}
        body={importBody}
        show={importShow}
        size={importSize || 'md'}
        onHide={() => setImportShow(false)}
      />
    </>
  );
};

EmployeeDataTable.propTypes = {
  showFilters: PropTypes.bool
};

EmployeeDataTable.defaultProps = {
  showFilters: false
};

export default EmployeeDataTable;
